export const ERROR = 'ERROR'
export const CLEAR_ERRORS = 'CLEAR_ERRORS'
export const LOADING = 'LOADING'